export const VoteStars = ({ score }: { score: number | undefined }): JSX.Element => {
  if (score === undefined) {
    return <span></span>;
  }
  const stars = Array.from({ length: 5 }, (_, index) => {
    const i = index + 1;
    let starType = i <= score ? "fa-star" : "fa-star-o";
    if (score - i + 1 === 0.5) {
      starType = "fa-star-half-o";
    }
    return <i key={i} className={`fa ${starType}`} aria-hidden="true"></i>;
  });
  return <span>{stars}</span>;
};
import React from "react";
